<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M21.5,0H2.5A2.5,2.5,0,0,0,0,2.5V22.985a.5.5,0,0,0,.805.4l5.56-4.277a.5.5,0,0,1,.3-.1H21.5A2.5,2.5,0,0,0,24,16.5V2.5A2.5,2.5,0,0,0,21.5,0ZM12,16.247a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,16.247Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,0,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,6.5a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z"
    />
  </svg>
</template>
